import React from "react";

const FooterEmpty = () => {
  return (
    <div className="base-sec-bottom">
      <p>
        {/* 전/현직 영어 시험 평가 전문 원어민(Rater)을 통한 여러분들의 영어 말하기
        능력을 점검해 보시고, 영어 말하기 학습에 도움이 되기를 바랍니다. */}
      </p>
    </div>
  );
};

export default FooterEmpty;
